<template>
  <div class="modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="products-modal" @click.stop>
        <div class="modal-content-signature" @click.stop>
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="signature-options-message mb-3" style="font-weight: bold; font-size: 1.3rem; color: #333;">
            Manage Your Signature
          </div>
          <div v-if="signature" class="card-body-top">
            <div v-if="signature" class="signature-options-message mb-2" style="font-weight: bold;">
              Current Signature
              <img :src="'data:image/png;base64,' + signature.user_image_base64" alt="User Signature"
                class="selected-image" />
            </div>
          </div>

          <hr />

          <div class="card-body">
            <div class="signature-options-message mb-2" style="font-weight: bold;">Draw New Signature</div>
            <form @submit.prevent="submitSignature" method="POST" autocomplete="off">
              <div class="signature-wrapper">
                <vueSignature ref="signature" :sigOption="option" :disabled="disabled"
                  @endStroke="onStrokeEnd"></vueSignature>
              </div>
            </form>
            <div class="btn-container mt-2">
              <button @click.prevent="submitSignature" class="btn btn-success m-1" :disabled="!hasDrawing || saving"
                :title="hasDrawing ? '' : 'Draw your signature first'">Save</button>
              <button @click.prevent="clear" class="btn btn-info m-1" :disabled="!hasDrawing || saving">Clear</button>
            </div>
          </div>

          <hr />

          <div class="card-body">
            <div class="signature-options-message mb-2" style="font-weight: bold;">Or Upload a new Signature</div>
            <input type="file" accept="image/*" @change="handleFileUpload" class="form-control mb-2" />
            <div v-if="uploadedImage" class="uploaded-preview mb-2">
              <h5>Preview</h5>
              <img :src="uploadedImage" alt="Uploaded Signature" class="selected-image" />
            </div>
            <button v-if="uploadedImage" @click="submitUploadedSignature" class="btn btn-success m-1">Save Uploaded
              Signature</button>
          </div>

          <button @click="close" class="btn btn-secondary mt-3" style="float: left;">Close</button>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import vueSignature from "vue-signature";
import axios from "axios";

export default {
  props: {
    role: {
      type: String,
      required: true
    },
  },
  components: {
    vueSignature,
  },
  data() {
    return {
      books: [],
      signature: null, // single signature for user
      uploadedImage: null,
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "#FAF9F6",
      },
      disabled: false,
      hasDrawing: false,
      saving: false,
      isVisible: false,
      user_id: null,
    };
  },
  mounted() {
    this.isVisible = true;
    this.user_id = parseInt(localStorage.getItem('user_id'));  // Retrieve user_id when component mounts
    console.log("user_id in sign modal", this.user_id);
    console.log("Role", this.role);
    this.getSignature();
  },
  methods: {
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    async getSignature() {  // Revised to use user_id from data
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      axios.get(`/api/store_image/fetch_image/${this.user_id}`, { headers })
        .then((response) => {
          this.books = response.data;
          this.signature = this.books.find(
            (item) => parseInt(item.user_id) === this.user_id && item.role === this.role
          );
          console.log('books', this.books);

          if (this.signature) {
            console.log("Found matching signature:", this.signature);
          } else {
            console.log("No matching signature found for this user/role.");
          }
          console.log('signature', this.signature);
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    onStrokeEnd() {
      this.hasDrawing = !this.$refs.signature.isEmpty();
    },
    // Flags drawings that are probably accidental: a dot, a tiny scratch,
    // or a single short line, based on the stroke points signature_pad records
    isLikelyAccidental() {
      const strokes = this.$refs.signature.sig.toData() || [];
      const points = strokes.flatMap(stroke => stroke.points || []);
      if (points.length === 0) return true;

      const xs = points.map(p => p.x);
      const ys = points.map(p => p.y);
      const width = Math.max(...xs) - Math.min(...xs);
      const height = Math.max(...ys) - Math.min(...ys);

      return points.length < 15 || (width < 80 && height < 25);
    },
    confirmDrawnSignature() {
      const warnings = [];
      if (this.isLikelyAccidental()) {
        warnings.push('The signature you drew looks very small, like a dot or an accidental mark.');
      }
      if (this.signature) {
        warnings.push('Saving will replace your current signature.');
      } else {
        warnings.push('This signature will be used when you sign off logbooks.');
      }
      return window.confirm(`${warnings.join('\n\n')}\n\nDo you want to save this signature?`);
    },
    async submitSignature() {
      if (this.saving) return;
      if (!this.hasDrawing || this.$refs.signature.isEmpty()) {
        alert('Please draw your signature before saving.');
        return;
      }
      if (!this.confirmDrawnSignature()) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const png = this.$refs.signature.save();
      this.saving = true;

      console.log('Submitting signature payload:', {
        user_image: png,
        user_id: this.user_id,
        role: this.role,
        is_selected: true
      });

      try {
        if (this.signature) {
          await axios.put(
            `/api/update_signature/${this.signature.id}`,
            {
              user_image: png,
              user_id: this.user_id,
              role: this.role,
              is_selected: true
            },
            { headers }
          );
          alert('Signature updated successfully!');
        } else {
          const response = await axios.post(
            '/api/sign',
            {
              user_image: png,
              user_id: this.user_id,
              role: this.role,
              is_selected: true
            },
            { headers }
          );

          const newSignature = response.data;
          alert('Signature saved successfully!');
          console.log('new', newSignature);
        }

        this.clear();
        this.$emit('close');

      } catch (error) {
        console.error('Error submitting signature:', error);
      } finally {
        this.saving = false;
      }
    },
    clear() {
      this.$refs.signature.clear();
      this.hasDrawing = false;
    },
    selectSignature(signature) {
      this.selectedSignature = signature;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async submitUploadedSignature() {
      if (!this.uploadedImage) return;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      await this.saveOrUpdateSignature(this.uploadedImage, headers);
    },
    async saveOrUpdateSignature(imageData, headers) {
      try {
        if (this.signature && this.signature.id) {
          // update existing signature
          await axios.put(`/api/update_signature/${this.signature.id}`, {
            user_image: imageData,
            user_id: this.user_id,
            role: this.role,
          }, { headers });
        } else {
          // create new signature
          await axios.post(`/api/sign`, {
            user_image: imageData,
            user_id: this.user_id,
            role: this.role,
            is_selected: true,
          }, { headers });
        }
        await this.getSignature();
        this.uploadedImage = null;
        this.clear();
        this.$emit('close');
      } catch (error) {
        console.error("Error saving signature:", error);
      }
    }
  },
};
</script>


<style scoped>
ul {
  list-style: none;
}

.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.products-modal {
  background-color: #fff;
  max-width: 1250px;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1001;
  display: block;
}

.modal-content-signature {
  position: relative;
  max-height: 94vh;
  overflow-y: auto;
  padding: 15px;
}

.card {
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body-top {
  padding: 10px;
  background-color: #bebebe;
  border: 1px solid #797979;
  border-radius: 4px;
}

.card-body {
  padding: 20px;
  background-color: #bebebe;
  border: 1px solid #797979;
  border-radius: 4px;
}

.btn-container {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
  margin-left: 20%;
  margin-right: 20%;
}

.btn {
  padding: 10px 20px;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  min-width: 100px;
}

.btn-info {
  border: 1px solid rgb(1, 112, 146);
  background-color: rgb(55, 157, 175);
  color: white;
}

.btn-info:hover {
  border: 1px solid rgb(1, 112, 146);
  background-color: rgb(43, 119, 133);
  color: white;
}

.btn-success {
  border: 1px solid rgb(16, 94, 26);
}

.btn-secondary {
  border: 1px solid rgb(59, 59, 59);
}

button.btn-info:hover {
  background-color: rgb(0, 131, 124);
}

button.btn-success:hover {
  background-color: rgba(21, 122, 35, 0.9);
}

button.btn-secondary:hover {
  background-color: rgba(77, 75, 75, 0.9);
}

.btn-container .btn:disabled,
.btn-container .btn:disabled:hover {
  opacity: 0.45;
  /* Bootstrap sets pointer-events: none, which hides the cursor and tooltip */
  pointer-events: auto;
  cursor: not-allowed;
  filter: grayscale(30%);
}

button.btn-info:disabled:hover {
  background-color: rgb(55, 157, 175);
}

button.btn-success:disabled:hover {
  background-color: #198754;
}

.selected-image {
  width: 300px;
  max-height: 120px;
  border: 2px solid #007bff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.signature-wrapper {
  width: 900px;
  height: 222px;
}

.form-control {
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
</style>